import { UtilityService } from '@eforall/common';
import { DialogService, GridSetup } from '@eforall/dashboard';
import { FinalPresentation } from '../final-presentation-view.part';
import { getActions } from './get-actions';
import { getColumns } from './get-columns';
import { AcceleratorAreaService } from '../../../../accelerator-area.service';


export function getSetup(util: UtilityService, dialogService: DialogService, accAreaService: AcceleratorAreaService): GridSetup<FinalPresentation> {

	return {
		rowName: { singular: 'Venture', plural: 'Ventures' },
		getRowKey: row => '' + row.accVentureId,
		stateKey: 'accelerator-final-presentation-grid',
		actions: getActions(dialogService, accAreaService),
		buttons: [],
		columns: getColumns(util),
	}
}
